import BC from './clientes/BC.png';
import Saff from './clientes/Saff.png';
import Tac from './clientes/Tac.png';
import Beviani from './clientes/Beviani.png';
import Sanmartino from './clientes/Sanmartino.png';
import gh from './clientes/gh.png';
import Betel from './clientes/Betel.png';
import Contrans from './clientes/Contrans.png';
import MWM from './clientes/MWM.png';
import Baroncello from './clientes/Baroncello.png';
import Transmoor from './clientes/transmoor.png';
import smLog from './clientes/smLog.png';
import Simas from './clientes/Simas.png';
import PTC from './clientes/PTC.png';
import GTL from './clientes/GTL.png';
import RTM from './clientes/RTM.png';
import Portolog from './clientes/Portolog.png';
import Portoex from './clientes/portoex.png';
import Vibelog from './clientes/Vibelog.png';
import Dumaszak from './clientes/Dumaszak.png';
import EIL from './clientes/EIL.png';
import MGE from './clientes/MGE.png';
import Spiazzi from './clientes/Spiazzi.png';
import ComexCargo from './clientes/ComexCargo.png';
import Jomar from './clientes/Jomar.png';
import SemFronteiras from './clientes/SemFronteiras.png';
import Transcosta from './clientes/transcosta.png';
import Kobrasol from './clientes/Kobrasol.png';
import Barcellos from './clientes/Barcellos.png';
import Froes from './clientes/Froes.png';
import Elo from './clientes/Elo.png';
import Nardi from './clientes/Nardi.png';
import lfCargo from './clientes/lfCargo.png';
import Comavix from './clientes/Comavix.png';
import Sudden from './clientes/Sudden.png';
import AJ from './clientes/AJ.png';

export default{
  BC,
  Saff,
  Tac,
  Beviani,
  Sanmartino,
  gh,
  Betel,
  Contrans,
  MWM,
  Baroncello,
  Transmoor,
  smLog,
  Simas,
  PTC,
  GTL,
  RTM,
  Portolog,
  Portoex,
  Vibelog,
  Dumaszak,
  EIL,
  MGE,
  Spiazzi,
  ComexCargo,
  Jomar,
  SemFronteiras,
  Transcosta,
  Kobrasol,
  Barcellos,
  Froes,
  Nardi,
  lfCargo,
  Elo,
  Comavix,
  Sudden,
  AJ
};
